import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Icon from "./Icon";
export default function ActionAreaCard() {
  const startDate = new Date(2021, 3, 8);// april 8th 2021
  const endDate = new Date(); // April 18th 2022
  const monthDiff =endDate.getMonth() -startDate.getMonth() +12 * (endDate.getFullYear() - startDate.getFullYear());
  console.log(monthDiff); // 27
  return (
    <Card
     className="exc border"
      style={{
       
    cursor:"default",
        boxShadow: "8px 8px 2px lightblue",
      }}
    >
      <CardActionArea>
        <CardContent>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            className="text"
            style={{
              fontSize: "32px",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="animateSpin">
              <Icon iconType={"React"} />
            </div>
            REACT DEVELOPER
          </Typography>
          <Typography
            gutterBottom
            variant="p"
            component="div"
            className="text"
            style={{ fontWeight: "bold" }}
          >
            2021-Present
          </Typography>
          <Typography
            gutterBottom
            variant="p"
            component="div"
            className="text"
            style={{  fontSize: "24px", fontWeight: "bold" }}
          >
            TCS l Bengaluru , India
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            className="text"
            style={{ fontSize: "16px" }}
          >
            I am a qualified and professional Frontend developer with <span className="text-[#17A6DB] dark:text-[#30dada] font-bold"> {monthDiff}</span> month of experience
            in website development. Strong creative and analytical skills. Team
            player with an eye for detail.
          </Typography>
          <Typography
            variant="body2"
            
            className="note"
            style={{
        
              fontSize: "16px",
              marginTop: "8px",
              fontWeight: "bold",
            }}
          >
            Note: You want to see my expertise details. You can expand every technology and
            check it out.
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
